import {
  SET_PRICE,
  SET_AMOUNT,
  SET_MAKER_COLLATERAL,
  SET_COLLATERAL,
	SET_ORDER_TYPE,
  SET_HELP,
  SET_MARKET,
  OVERRIDE_PENDING_TRANSACTIONS,
  NEW_EVENT,
  REMOVE_EVENT
} from '../types';
import {scheduleTransfer} from '../transfers/set/schedule';

export function deletePending(orders,state,dispatch){
  let pendingTransactions = state.pending.transactions;
  let latestBlock = state.socket.latestBlock;
  orders.filter(o=>o.dontRemove == null || o.dontRemove == false).forEach((o)=>{
    if(pendingTransactions) {
      if(o.type && latestBlock && latestBlock.blockchainHeaders && latestBlock.blockchainHeaders[`${o.type.toLowerCase()}List`] && latestBlock.blockchainHeaders[`${o.type.toLowerCase()}List`][latestBlock.blockchainHeaders[`${o.type.toLowerCase()}List`].length -1] && o.height > latestBlock.blockchainHeaders[`${o.type.toLowerCase()}List`][latestBlock.blockchainHeaders[`${o.type.toLowerCase()}List`].length -1].height){
        // console.log(latestBlock.blockchainHeaders[`${o.type.toLowerCase()}List`][latestBlock.blockchainHeaders[`${o.type.toLowerCase()}List`].length -1].height)
      }
      else {
        delete pendingTransactions[o.txHash];
      }
    }
  });
  dispatch({
    type:OVERRIDE_PENDING_TRANSACTIONS,
    payload: pendingTransactions
  });
}

export function triggerEvents(orders,state,dispatch){
  let events = state.scheduled_events.events;
  for(let order of orders){
    let event = null;
    if(events[order.maker.txHash]){
      //schedule maker transfer event
      event = events[order.maker.txHash];
      event.to = order.taker.receivesToAddress;
      let {password,amount,to,chain} = event;
      dispatch({type:REMOVE_EVENT,payload:event.txHash})
      scheduleTransfer({chain,password,amount,to},dispatch,state,(err,hash)=>{
        if(!err) {}
        else {
          console.log({err})
          dispatch({type:NEW_EVENT,payload:event})
        }
      })
    }

    if(events[order.txHash]){
      //schedule taker transfer event
      event = events[order.txHash];
      let {password,amount,to,chain, txHash} = event;
      dispatch({type:REMOVE_EVENT,payload:event.txHash})
      scheduleTransfer({chain,password,amount,to},dispatch,state,(err,hash)=>{
        if(!err) {}
        else {
          console.log({err});
          // dispatch({type:NEW_EVENT,payload:event})
        }
      })
    }
  };
}

export function setPrice(view,done) {
  return function(dispatch) {
    dispatch({
      type: SET_PRICE,
      payload:view
    });
    setTimeout(()=>{done()},200);
  }
}

export function setAmount(view,done) {
  return function(dispatch) {
    dispatch({
      type: SET_AMOUNT,
      payload:view
    });
    if(done) done()
  }
}

export function setCollateral(view,done) {
  return function(dispatch) {
    dispatch({
      type: SET_COLLATERAL,
      payload:view
    });
    done()
  }
}

export function setMakerCollateral(view,done) {
  return function(dispatch) {
    dispatch({
      type: SET_MAKER_COLLATERAL,
      payload:view
    });
    done()
  }
}

export function setOrderType(type) {
  return function(dispatch) {
    dispatch({
      type: SET_ORDER_TYPE,
      payload:type
    });
  }
}

export function setMarket(market,done) {
  return function(dispatch) {
    dispatch({
      type: SET_MARKET,
      payload:market
    });
  }
}

export function setHelp(help,done) {
  return function(dispatch) {
    dispatch({
      type: SET_HELP,
      payload:help
    });
  }
}
